import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-12tkdds-0"
})(["display:inline-block;display:", ";position:relative;flex-shrink:0;", ";"], function (_ref) {
  var _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'inline-block' : _ref$display;
  return display;
}, minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: ", ";\n  "])), function (_ref2) {
  var _ref2$fullWidth = _ref2.fullWidth,
    fullWidth = _ref2$fullWidth === void 0 ? false : _ref2$fullWidth;
  return fullWidth ? 'relative' : 'static';
}));